import { useAuthStore } from 'store/auth.store';

const MAXIMOR_EMAIL_DOMAINS = ['@maximor.ai'] as const;

export const useIsMaximorUser = (): boolean => {
  const email = useAuthStore((state) => state.user?.email);
  return (
    MAXIMOR_EMAIL_DOMAINS.some((domain) => email?.endsWith(domain)) ?? false
  );
};
